import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Injector, ViewChild, ViewContainerRef } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { CustomerRepository } from '../../../../shared/repositories/customer.repository';
import { AuthService } from '../../../../pages/auth/auth.service';
import { CustomerProfileDto } from '../../../../api/v1/models/customer-profile-dto';

@UntilDestroy()
@Component({
  selector: 'app-account-preview',
  templateUrl: './account-preview.component.html',
  styleUrls: ['./account-preview.component.scss'],
  standalone: true,
  imports: [NgIf, RouterLink, AsyncPipe]
})

export class AccountPreviewComponent {
  constructor(
    private customerRepository: CustomerRepository,
    private injector: Injector,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
  ) {
    this.authService.showAuthModalSubj$.subscribe(() => {
      this._onLogin();
    })
  }

  @ViewChild('authModalView', { read: ViewContainerRef }) authComponentRef: ViewContainerRef;

  public customerProfile$: Observable<CustomerProfileDto | null> = this.customerRepository.customerProfile$;

  onLogin() {
    this.authService.setRedirectToPersonalPage(true);
    this._onLogin();
  }

  private _onLogin(): void {
    this.authComponentRef.clear();
    import('../../../../pages/auth/auth.component').then(c => {
      const componentRef = this.authComponentRef.createComponent(c.AuthComponent, { injector: this.injector });
      componentRef.instance.closeModal.pipe(untilDestroyed(this)).subscribe(() => this.authComponentRef.clear());
      componentRef.changeDetectorRef.detectChanges()
      this.cdr.detectChanges();
    });
  }
}
